import React, { useEffect, useState } from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Download, Share, Plus, Smartphone } from "lucide-react";
import { canInstall, onInstallableChange, promptInstall, isStandalone, isIOS } from "../../lib/pwa";
import { toast } from "sonner";

export default function GetTheApp() {
  const [installable, setInstallable] = useState(canInstall());
  const [showIos, setShowIos] = useState(false);
  useEffect(() => onInstallableChange(setInstallable), []);

  if (isStandalone()) return null; // already installed — no prompts

  const ios = isIOS();

  const install = async () => {
    const res = await promptInstall();
    if (res.outcome === "accepted") toast.success("Installing COMMITMENTT…");
    else if (res.outcome === "unavailable") toast("Use your browser menu to install, or add to Home Screen.");
  };

  return (
    <Card className="rounded-2xl border-border shadow-card-sm p-5" data-testid="get-the-app">
      <div className="flex items-center gap-2 mb-2"><Smartphone size={18} className="text-navy" /><p className="text-sm font-medium text-ink">Get the app</p></div>
      <p className="text-xs text-slatey mb-3">Keep your commitments within reach. Install COMMITMENTT for quicker access and supported commitment notifications.</p>

      {ios ? (
        <>
          <Button variant="secondary" onClick={() => setShowIos((s) => !s)} className="rounded-full bg-secondary text-ink w-full justify-start" data-testid="ios-install-btn">
            <Share size={15} className="mr-2" />Add COMMITMENTT to your iPhone
          </Button>
          {showIos && (
            <ol className="text-xs text-slatey mt-3 space-y-1.5 list-decimal pl-4" data-testid="ios-steps">
              <li>Open COMMITMENTT in Safari.</li>
              <li>Tap the <span className="inline-flex items-center gap-0.5"><Share size={11} /> Share</span> button.</li>
              <li>Choose <span className="font-medium">Add to Home Screen</span> <Plus size={11} className="inline" />.</li>
              <li>Confirm <span className="font-medium">Add</span>.</li>
            </ol>
          )}
        </>
      ) : installable ? (
        <Button onClick={install} className="rounded-full bg-navy text-white hover:bg-navy-light w-full" data-testid="install-btn">
          <Download size={15} className="mr-2" />Install COMMITMENTT
        </Button>
      ) : (
        <p className="text-xs text-muted-foreground">To install, use your browser's menu → "Install app" / "Add to Home Screen". You can keep using COMMITMENTT in the browser too.</p>
      )}
    </Card>
  );
}
